import { render, staticRenderFns } from "./SalesOrderPayments.vue?vue&type=template&id=7022ea7a&scoped=true"
import script from "./SalesOrderPayments.vue?vue&type=script&lang=js"
export * from "./SalesOrderPayments.vue?vue&type=script&lang=js"
import style0 from "./SalesOrderPayments.vue?vue&type=style&index=0&id=7022ea7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7022ea7a",
  null
  
)

export default component.exports